import { getEnv } from 'util/getEnv';

const FAILURE_THRESHOLD = 3;
const RELOAD_SAFETY_TIMEOUT_MS = 10000;

let failureCount = 0;
let reloadPromise = null;

export const resetRecaptchaFailures = () => {
  failureCount = 0;
};

export const recordRecaptchaFailure = () => {
  failureCount += 1;
  if (failureCount >= FAILURE_THRESHOLD && !reloadPromise) {
    reloadRecaptchaScript();
  }
};

export const awaitReloadIfPending = async () => {
  if (reloadPromise) await reloadPromise;
};

export const reloadRecaptchaScript = () => {
  if (reloadPromise) return reloadPromise;

  reloadPromise = new Promise(resolve => {
    window.grecaptcha = undefined;

    document
      .querySelectorAll('script[src*="recaptcha/enterprise.js"]')
      .forEach(node => node.parentNode?.removeChild(node));

    const previousCallback = window.onRecaptchaLoad;
    let resolved = false;
    const finish = () => {
      if (resolved) return;
      resolved = true;
      resolve();
    };

    window.onRecaptchaLoad = () => {
      if (typeof previousCallback === 'function') previousCallback();
      finish();
    };

    const script = document.createElement('script');
    const key = getEnv('REACT_APP_RECAPTCHA_KEY');
    script.src = `https://www.google.com/recaptcha/enterprise.js?onload=onRecaptchaLoad&render=${key}`;
    script.async = true;
    script.defer = true;
    script.onerror = finish;
    document.head.appendChild(script);

    setTimeout(finish, RELOAD_SAFETY_TIMEOUT_MS);
  }).finally(() => {
    reloadPromise = null;
    failureCount = 0;
  });

  return reloadPromise;
};
